import moment from "moment";
import axios from "helpers/_axios";
import * as pageName from "./pageAction";
import * as fileStatuses from "helpers/fileStatus.json";
import { getFileStatusGroup, isPending } from "helpers/file";
export const GET_TREE = "GET_TREE";
export const REFRESH_TREE = "REFRESH_TREE";
export const LOADING_TREE = "LOADING_TREE";

// Children Tree
export const LOADING_CHILDREN_TREE = "LOADING_CHILDREN_TREE";
export const CHILDREN_TREE = "CHILDREN_TREE";
export const ERROR_CHILDREN_TREE = "ERROR_CHILDREN_TREE";

// Subordinate
export const SUBORDINATE = "SUBORDINATE";

export const LOADING_FILE_COUNT = "LOADING_FILE_COUNT";
export const GET_FILE_COUNT = "GET_FILE_COUNT";

export const LOADING_FILE_UPLOAD_COUNT = "LOADING_FILE_UPLOAD_COUNT";
export const GET_FILE_UPLOAD_COUNT = "GET_FILE_UPLOAD_COUNT";

export const LOADING_FILE = "LOADING_FILE";
export const GET_FILE = "GET_FILE";
export const GET_FILES = "GET_FILES";
export const GENERATE_CSV = "GENERATE_CSV";
export const MULTIPLE_SELECTED_FILE = "MULTIPLE_SELECTED_FILE";
export const GET_NEXT_FILE = "GET_NEXT_FILE";
export const ACTIVE_TAB = "ACTIVE_TAB";
export const UPDATE_FILE = "UPDATE_FILE";

export const LOADING_DELETED_FILES = "LOADING_DELETED_FILES";
export const GET_DELETED_FILES = "GET_DELETED_FILES";
export const ERROR_DELETED_FILES = "ERROR_DELETED_FILES";

export const LOADING_IMPORTED_FILES = "LOADING_IMPORTED_FILES";
export const GET_IMPORTED_FILES = "GET_IMPORTED_FILES";
export const ERROR_IMPORTED_FILES = "ERROR_IMPORTED_FILES";

// Retry failed upload
export const LOADING_RETRY_FILE_UPLOAD = "LOADING_RETRY_FILE_UPLOAD";
export const RETRY_FILE_UPLOAD = "RETRY_FILE_UPLOAD";
export const ERROR_RETRY_FILE_UPLOAD = "ERROR_RETRY_FILE_UPLOAD";

// Retry failed uploads
export const LOADING_RETRY_FILE_UPLOAD_JOB = "LOADING_RETRY_FILE_UPLOAD_JOB";
export const RETRY_FILE_UPLOAD_JOB = "RETRY_FILE_UPLOAD_JOB";
export const ERROR_RETRY_FILE_UPLOAD_JOB = "ERROR_RETRY_FILE_UPLOAD_JOB";

export const BULK_REVIEW_ADD_FILE = "BULK_REVIEW_ADD_FILE";
export const BULK_REVIEW_ADD_FILE_COUNT = "BULK_REVIEW_ADD_FILE_COUNT";
export const ERROR_FILE = "ERROR_FILE";
export const SAMPLE_PDF_FILE = "SAMPLE_PDF_FILE";
const querystring = require("querystring");

export const getTree =
  ({
    client,
    fileStatus,
    parentPath = "",
    searchQuery = "",
    subordinateId = ""
  }) =>
  async dispatch => {
    if (!client || !fileStatus) return;

    fileStatus = getFileStatusGroup(fileStatus);

    dispatch({
      type: LOADING_TREE,
      payload: true
    });

    try {
      const result = await axios().get(`/files/web/tree`, {
        params: {
          client_id: client.id,
          department_item_value: client.department_item_value,
          status: fileStatus.join(","),
          materialized_path: parentPath,
          search_query: searchQuery,
          subordinate_id: subordinateId
        }
      });

      if (result?.data?.data[0]?.files[0]?.id) {
        const firstFileDocId = result.data.data[0].files[0].id;
        axios()
          .get(`/files/${firstFileDocId}`)
          .then(firstFileResult => {
            if (firstFileResult?.data?.data) {
              dispatch(setSelectedFile(firstFileResult.data.data));
            }
          })
          .catch(error => console.error(error));
      }

      dispatch({
        type: LOADING_TREE,
        payload: false
      });
      dispatch({
        type: GET_TREE,
        payload: result.data.data
      });

      // Get file count
      dispatch(getFileStatusCount(client));
    } catch (error) {
      console.error("@getTree", error);
      dispatch({
        type: LOADING_TREE,
        payload: false
      });
      dispatch({
        type: GET_TREE,
        payload: []
      });
      return dispatch({
        type: ERROR_FILE,
        payload: error
      });
    }
  };

export const getChildrenTree =
  ({ client, fileStatus, parentPath = "", searchQuery = "" }) =>
  async dispatch => {
    if (!client || !fileStatus) return;
    fileStatus = getFileStatusGroup(fileStatus);

    dispatch({
      type: LOADING_CHILDREN_TREE,
      payload: true
    });

    try {
      if (searchQuery) {
        // Remove special chars
        searchQuery = searchQuery.replace(/[<>:"/\\|?*]/g, "");
      }

      const result = await axios().get(`/files/web/tree`, {
        params: {
          client_id: client.id,
          department_item_value: client.department_item_value,
          status: fileStatus.join(","),
          materialized_path: parentPath,
          search_query: searchQuery
        }
      });

      const firstFileDocInTree = result.data.data[0];
      dispatch(setSelectedFile(firstFileDocInTree));
      dispatch({
        type: LOADING_CHILDREN_TREE,
        payload: false
      });
      dispatch({
        type: CHILDREN_TREE,
        payload: result.data.data
      });
    } catch (error) {
      console.error("@getChildrenTree", error);
      dispatch({
        type: LOADING_CHILDREN_TREE,
        payload: false
      });
      dispatch({
        type: CHILDREN_TREE,
        payload: []
      });
      return dispatch({
        type: ERROR_CHILDREN_TREE,
        payload: error
      });
    }
  };

export const getAllFiles =
  ({
    fileId = "",
    rawFilename = "",
    metadataNames = [],
    desktopUsernames = [],
    webUsernames = [],
    clients = [],
    departments = [],
    departmentItemValues = [],
    dataEntryStartDate = "",
    dataEntryEndDate = "",
    webUserApprovalStartDate = "",
    webUserApprovalEndDate = "",
    dmsUploadStartDate = "",
    dmsUploadEndDate = "",
    status = "",
    page = 1,
    limit = 10
  }) =>
  async dispatch => {
    dispatch({
      type: LOADING_FILE,
      payload: true
    });
    dispatch({
      type: GET_FILES,
      payload: []
    });
    const queryStringObject = {
      file_id: fileId,
      raw_filename: rawFilename,
      metadata_names: metadataNames,
      clients,
      desktop_usernames: desktopUsernames,
      web_usernames: webUsernames,
      departments,
      department_item_values: departmentItemValues,
      data_entry_start_date: dataEntryStartDate
        ? moment(dataEntryStartDate).format("YYYY-MM-DD")
        : "",
      data_entry_end_date: dataEntryEndDate
        ? moment(dataEntryEndDate).add(1, "days").format("YYYY-MM-DD")
        : "",
      web_approval_start_date: webUserApprovalStartDate
        ? moment(webUserApprovalStartDate).format("YYYY-MM-DD")
        : "",
      web_approval_end_date: webUserApprovalEndDate
        ? moment(webUserApprovalEndDate).add(1, "days").format("YYYY-MM-DD")
        : "",
      dms_upload_start_date: dmsUploadStartDate
        ? moment(dmsUploadStartDate).format("YYYY-MM-DD")
        : "",
      dms_upload_end_date: dmsUploadEndDate
        ? moment(dmsUploadEndDate).add(1, "days").format("YYYY-MM-DD")
        : "",
      status,
      page,
      limit
    };

    try {
      const result = await axios().get(
        `/files?${querystring.stringify(queryStringObject)}`
      );
      return dispatch({
        type: GET_FILES,
        payload: result.data
      });
    } catch (error) {
      dispatch({
        type: GET_FILES,
        payload: []
      });
      dispatch({
        type: ERROR_FILE,
        payload: error
      });
    } finally {
      dispatch({
        type: LOADING_FILE,
        payload: false
      });
    }
  };

export const getAllDeletedFiles =
  ({ rawFilename = "", page = 1, limit = 10 }) =>
  async dispatch => {
    dispatch({
      type: LOADING_DELETED_FILES,
      payload: true
    });
    dispatch({
      type: GET_DELETED_FILES,
      payload: []
    });
    const queryStringObject = {
      raw_filename: rawFilename,
      page,
      limit
    };

    try {
      const result = await axios().get(
        `/files/web/deleted-files?${querystring.stringify(queryStringObject)}`
      );
      return dispatch({
        type: GET_DELETED_FILES,
        payload: result.data
      });
    } catch (error) {
      dispatch({
        type: GET_DELETED_FILES,
        payload: []
      });
      dispatch({
        type: ERROR_DELETED_FILES,
        payload: error
      });
    } finally {
      dispatch({
        type: LOADING_DELETED_FILES,
        payload: false
      });
    }
  };

export const getAllImportedFiles =
  ({ rawFilename = "", page = 1, limit = 10 }) =>
  async dispatch => {
    dispatch({
      type: LOADING_IMPORTED_FILES,
      payload: true
    });
    dispatch({
      type: GET_IMPORTED_FILES,
      payload: []
    });
    const queryStringObject = {
      raw_filename: rawFilename,
      page,
      limit
    };

    try {
      const result = await axios().get(
        `/files/web/imported-files?${querystring.stringify(queryStringObject)}`
      );
      return dispatch({
        type: GET_IMPORTED_FILES,
        payload: result.data
      });
    } catch (error) {
      dispatch({
        type: GET_IMPORTED_FILES,
        payload: []
      });
      dispatch({
        type: ERROR_IMPORTED_FILES,
        payload: error
      });
    } finally {
      dispatch({
        type: LOADING_IMPORTED_FILES,
        payload: false
      });
    }
  };

export const generateCSVLink =
  ({
    fileId = "",
    rawFilename = "",
    metadataNames = [],
    desktopUsernames = [],
    webUsernames = [],
    clients = [],
    departments = [],
    departmentItemValues = [],
    dataEntryStartDate = "",
    dataEntryEndDate = "",
    webUserApprovalStartDate = "",
    webUserApprovalEndDate = "",
    dmsUploadStartDate = "",
    dmsUploadEndDate = "",
    status = "",
    jobType = ""
  }) =>
  async dispatch => {
    dispatch({
      type: LOADING_FILE,
      payload: true
    });
    dispatch({
      type: GENERATE_CSV,
      payload: ""
    });

    const queryStringObject = {
      file_id: fileId,
      raw_filename: rawFilename,
      metadata_names: metadataNames,
      clients,
      desktop_usernames: desktopUsernames,
      web_usernames: webUsernames,
      departments,
      department_item_values: departmentItemValues,
      data_entry_start_date: dataEntryStartDate
        ? moment(dataEntryStartDate).format("YYYY-MM-DD")
        : "",
      data_entry_end_date: dataEntryEndDate
        ? moment(dataEntryEndDate).add(1, "days").format("YYYY-MM-DD")
        : "",
      web_approval_start_date: webUserApprovalStartDate
        ? moment(webUserApprovalStartDate).format("YYYY-MM-DD")
        : "",
      web_approval_end_date: webUserApprovalEndDate
        ? moment(webUserApprovalEndDate).add(1, "days").format("YYYY-MM-DD")
        : "",
      dms_upload_start_date: dmsUploadStartDate
        ? moment(dmsUploadStartDate).format("YYYY-MM-DD")
        : "",
      dms_upload_end_date: dmsUploadEndDate
        ? moment(dmsUploadEndDate).add(1, "days").format("YYYY-MM-DD")
        : "",
      status: status,
      job_type: jobType
    };

    try {
      const result = await axios().post(
        `/files/web/export-to-csv?${querystring.stringify(queryStringObject)}`
      );
      return dispatch({
        type: GENERATE_CSV,
        payload: result.data.data
      });
    } catch (error) {
      dispatch({
        type: GENERATE_CSV,
        payload: ""
      });
      dispatch({
        type: ERROR_FILE,
        payload: error
      });
    } finally {
      dispatch({
        type: LOADING_FILE,
        payload: false
      });
    }
  };

export const retryFailedJobs = (clientId, status) => async dispatch => {
  dispatch({
    type: LOADING_RETRY_FILE_UPLOAD_JOB,
    payload: true
  });
  const queryStringObject = {
    client: clientId,
    status: status
  };

  try {
    const result = await axios().post(
      `/files/web/retry-failed-uploads?${querystring.stringify(
        queryStringObject
      )}`
    );
    dispatch({
      type: LOADING_RETRY_FILE_UPLOAD_JOB,
      payload: false
    });
    dispatch({
      type: ERROR_RETRY_FILE_UPLOAD_JOB,
      payload: null
    });
    dispatch({
      type: RETRY_FILE_UPLOAD_JOB,
      httpStatus: result.data.status,
      payload: result.data.data
    });
  } catch (error) {
    dispatch({
      type: LOADING_RETRY_FILE_UPLOAD_JOB,
      payload: false
    });
    dispatch({
      type: ERROR_RETRY_FILE_UPLOAD_JOB,
      payload: error
    });
    dispatch({
      type: RETRY_FILE_UPLOAD_JOB,
      payload: null
    });
  }
};

export const refreshTree = doRefresh => dispatch => {
  dispatch({
    type: REFRESH_TREE,
    payload: doRefresh
  });
};

export const setSubordinate = subordinate => async dispatch => {
  if (!subordinate) return;
  return dispatch({
    type: SUBORDINATE,
    payload: subordinate
  });
};

export const getFile = id => async dispatch => {
  if (!id) return;
  dispatch({
    type: GET_FILE,
    payload: null
  });
  dispatch({
    type: LOADING_FILE,
    payload: true
  });
  let result = {};
  try {
    result = await axios().get(`/files/${id}`);
    result = result.data.data;
  } catch (error) {}
  dispatch({
    type: LOADING_FILE,
    payload: false
  });
  return dispatch({
    type: GET_FILE,
    payload: result
  });
};

export const selectMultipleFiles = files => async dispatch => {
  return dispatch({
    type: MULTIPLE_SELECTED_FILE,
    payload: files
  });
};

export const setActiveTab = status => async dispatch => {
  dispatch({
    type: ACTIVE_TAB,
    payload: status
  });
};

export const getActiveTab = () => async dispatch => {
  const activeTab = localStorage.getItem("active_tab");
  dispatch({
    type: ACTIVE_TAB,
    payload: activeTab
  });
};

export const setSelectedFile = fileDoc => dispatch => {
  dispatch({
    type: GET_FILE,
    payload: fileDoc
  });
};

export const clearSelectedFile = () => dispatch => {
  dispatch({
    type: GET_FILE,
    payload: null
  });
};

export const updateFile =
  ({ fileId, data }) =>
  async dispatch => {
    try {
      dispatch({
        type: LOADING_FILE,
        payload: true
      });
      const result = await axios().put(`/files/web/${fileId}`, data);
      dispatch({
        type: LOADING_FILE,
        payload: false
      });
      dispatch({
        type: ERROR_FILE,
        payload: null
      });
      dispatch({
        type: UPDATE_FILE,
        httpStatus: result.data.status,
        payload: result.data.data
      });
    } catch (error) {
      dispatch({
        type: LOADING_FILE,
        payload: false
      });
      dispatch({
        type: ERROR_FILE,
        payload: error
      });
      dispatch({
        type: UPDATE_FILE,
        httpStatus: 0,
        payload: null
      });
    }
  };

export const retryFileUpload = fileId => async dispatch => {
  try {
    dispatch({
      type: LOADING_RETRY_FILE_UPLOAD,
      payload: true
    });
    const result = await axios().put(`/files/web/${fileId}/retry-upload`);
    dispatch({
      type: LOADING_RETRY_FILE_UPLOAD,
      payload: false
    });
    dispatch({
      type: ERROR_RETRY_FILE_UPLOAD,
      payload: null
    });
    dispatch({
      type: RETRY_FILE_UPLOAD,
      httpStatus: result.data.status,
      payload: result.data.data
    });
  } catch (error) {
    dispatch({
      type: LOADING_RETRY_FILE_UPLOAD,
      payload: false
    });
    dispatch({
      type: ERROR_RETRY_FILE_UPLOAD,
      payload: error
    });
    dispatch({
      type: RETRY_FILE_UPLOAD,
      payload: null
    });
  }
};

export const resetHttpStatus = () => dispatch => {
  dispatch({
    type: UPDATE_FILE,
    httpStatus: 0,
    payload: null
  });
};

export const updateChat =
  ({ fileId, message }) =>
  async dispatch => {
    try {
      dispatch({
        type: LOADING_FILE,
        payload: true
      });
      const result = await axios().post(`/files/chat`, {
        file_id: fileId,
        message
      });
      dispatch({
        type: LOADING_FILE,
        payload: false
      });
      dispatch({
        type: ERROR_FILE,
        payload: null
      });
      dispatch({
        type: UPDATE_FILE,
        httpStatus: result.data.status,
        payload: result.data.data
      });
    } catch (error) {
      dispatch({
        type: LOADING_FILE,
        payload: false
      });
      dispatch({
        type: ERROR_FILE,
        payload: error
      });
      dispatch({
        type: UPDATE_FILE,
        httpStatus: 0,
        payload: null
      });
    }
  };

export const updateStatus =
  ({ clientId, data }) =>
  async dispatch => {
    try {
      dispatch({
        type: LOADING_FILE,
        payload: true
      });
      const result = await axios().put(
        `/files/web/bulk-status/${clientId}`,
        data
      );
      dispatch({
        type: LOADING_FILE,
        payload: false
      });
      dispatch({
        type: ERROR_FILE,
        payload: null
      });
      dispatch({
        type: UPDATE_FILE,
        httpStatus: result.data.status,
        payload: result.data.data
      });
    } catch (error) {
      dispatch({
        type: LOADING_FILE,
        payload: false
      });
      dispatch({
        type: ERROR_FILE,
        payload: error
      });
      dispatch({
        type: UPDATE_FILE,
        httpStatus: 0,
        payload: null
      });
    }
  };

export const saveBulkReview =
  ({ fileDocs, isDirectory = true, flushOld = false }) =>
  async dispatch => {
    const loggedUser = JSON.parse(localStorage.getItem("logged_user"));

    function _iterateChildrenNodes(children, files) {
      for (const child of children) {
        if (child.isFile) {
          let path = child.remote_cloud_path.split("/");
          files.push({
            ...child,
            path: path[1]
          });
        } else {
          _iterateChildrenNodes(child.children, files);
        }
      }
      return files;
    }

    const files = [];
    const fileItems = [];
    if (isDirectory) {
      for (const fileDoc of fileDocs) {
        if (fileDoc.isFile || !fileDoc.children) continue;
        fileItems.push(..._iterateChildrenNodes(fileDoc.children, files));
      }
    } else {
      fileItems.push(...fileDocs);
    }
    dispatch({
      type: BULK_REVIEW_ADD_FILE_COUNT,
      payload: fileItems.length
    });

    // Get old docs from the localstorage
    const lcBulkFiles =
      localStorage.getItem(`bulk_review_${loggedUser.id}`) || null;
    let oldFiles = lcBulkFiles ? JSON.parse(lcBulkFiles) : [];

    if (flushOld) {
      oldFiles = [];
    }
    const uniqueIds = [],
      finalFileList = [];
    fileItems.concat(oldFiles).forEach(file => {
      if (!uniqueIds.includes(file.id)) {
        finalFileList.push(file);
        uniqueIds.push(file.id);
      }
    });

    localStorage.setItem(
      `bulk_review_${loggedUser.id}`,
      JSON.stringify(finalFileList)
    );

    return dispatch({
      type: BULK_REVIEW_ADD_FILE,
      payload: finalFileList
    });
  };

export const getBulkReviews = () => dispatch => {
  const loggedUser = JSON.parse(localStorage.getItem("logged_user"));
  let lcBulkFiles = localStorage.getItem(`bulk_review_${loggedUser.id}`) || "";
  lcBulkFiles = lcBulkFiles ? JSON.parse(lcBulkFiles) : [];
  dispatch({
    type: BULK_REVIEW_ADD_FILE,
    payload: lcBulkFiles
  });
};

export const clearBulkReview = () => async dispatch => {
  const loggedUser = JSON.parse(localStorage.getItem("logged_user"));
  localStorage.removeItem(`bulk_review_${loggedUser.id}`);

  dispatch({
    type: BULK_REVIEW_ADD_FILE,
    payload: []
  });
};

export const setSamplePDF = activeTab => async dispatch => {
  let pdfFileName = "select_file.pdf";
  switch (activeTab) {
    case pageName.PAGE_ACTIVITY_TREE_VIEW:
      pdfFileName = "select_file.pdf";
      break;
    case pageName.PAGE_ACTIVITY_CLIENT_INFO:
      pdfFileName = "change_client.pdf";
      break;
    case pageName.PAGE_ACTIVITY_BULK_REVIEW:
      pdfFileName = "bulk_review.pdf";
      break;
    case pageName.PAGE_ACTIVITY_ACCURACY:
      pdfFileName = "accuracy_report.pdf";
      break;
    default:
      pdfFileName = "select_file.pdf";
      break;
  }

  dispatch({
    type: SAMPLE_PDF_FILE,
    payload: pdfFileName
  });
};

export const getFileStatusCount = client => async dispatch => {
  if (!client) return;
  dispatch({
    type: LOADING_FILE_COUNT,
    payload: true
  });
  let result = {
    [fileStatuses.STATUS_PENDING_REVIEW]: 0,
    [fileStatuses.STATUS_REJECTED]: 0,
    [fileStatuses.STATUS_DISCUSSIONS]: 0,
    [fileStatuses.STATUS_UPLOADED]: 0
  };

  try {
    const response = await axios().get(`/files/count/${client.id}`, {
      params: {
        department_item_value: client.department_item_value
      }
    });

    let oldPendingReviewCount = 0;
    for (const statusItem of response.data.data) {
      if (isPending(statusItem.id)) {
        oldPendingReviewCount += statusItem.count;
        result[fileStatuses.STATUS_PENDING_REVIEW] = oldPendingReviewCount;
      } else if (result[statusItem.id] >= 0) {
        result[statusItem.id] = statusItem.count;
      }
    }
  } catch (error) {}

  dispatch({
    type: LOADING_FILE_COUNT,
    payload: false
  });
  dispatch({
    type: GET_FILE_COUNT,
    payload: result
  });
};

export const getFileUploadStatusCount = client => async dispatch => {
  if (!client) return;
  dispatch({
    type: LOADING_FILE_UPLOAD_COUNT,
    payload: true
  });
  let result = {
    [fileStatuses.STATUS_READY_TO_UPLOAD]: 0,
    [fileStatuses.STATUS_IN_PROGRESS]: 0,
    [fileStatuses.STATUS_UPLOADED]: 0,
    [fileStatuses.STATUS_UPLOAD_FAILED]: 0
  };

  try {
    const response = await axios().get(`/files/web/upload-count/${client.id}`);

    for (const statusItem of response.data.data) {
      if (result[statusItem.id] >= 0) {
        result[statusItem.id] = statusItem.count;
      }
    }
  } catch (error) {}

  dispatch({
    type: LOADING_FILE_UPLOAD_COUNT,
    payload: false
  });
  dispatch({
    type: GET_FILE_UPLOAD_COUNT,
    payload: result
  });
};

export const resetPayload = type => dispatch => {
  dispatch({
    type: type,
    httpStatus: 0,
    payload: null
  });
};
